import script from "./VipRedeemDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./VipRedeemDialog.vue?vue&type=script&lang=ts&setup=true"

import "./VipRedeemDialog.vue?vue&type=style&index=0&id=250af9c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250af9c3"]])

export default __exports__